enum Property
{
	SingleFamilyHouse = 1,
	MultiFamilyHouse = 2,
	Apartment = 3,
	Company = 4
}

export default Property;